"use client";

import React from "react";

interface InfiniteMovingCardsProps {
  speed?: "fast" | "normal" | "slow"; // predefined speeds
  customDuration?: number;            // custom duration in seconds
  pauseOnHover?: boolean;            // pause animation on hover
  children?: React.ReactNode;         // cards to display
}

export const InfiniteMovingCards: React.FC<InfiniteMovingCardsProps> = ({
  speed = "normal",
  customDuration,
  pauseOnHover = true,
  children,
}) => {
  let duration: string;

  if (customDuration && customDuration > 0) {
    if (customDuration < 10 || customDuration > 3600) {
      // console.warn(
      //   `Invalid customDuration ${customDuration}. Must be between 10 and 3600 seconds.`
      // );
    }
    duration = `${customDuration}s`;
  } else {
    const presets: Record<string, string> = {
      fast: "20s",
      normal: "40s",
      slow: "80s",
    };
    duration = presets[speed] || "40s";
  }

  return (
    <div
      className="scroller relative z-20 w-full overflow-hidden [mask-image:linear-gradient(to_right,transparent,white_10%,white_90%,transparent)]"
      style={{ ["--animation-duration" as any]: duration }}
    >
      <ul className={`flex w-max min-w-full shrink-0 flex-nowrap gap-4 py-4 animate-scroll ${pauseOnHover ? 'hover:[animation-play-state:paused]' : ''}`}>
        {children}
      </ul>
    </div>
  );
};
